module.exports = __webpack_public_path__ + "media/buy-now/pug-7674ce45.png";